import { Session, Sessions, UnknownSession } from "accounts/domain/session"

export class TimeLimitedSessions implements Sessions {
  private readonly sessions: Sessions
  private readonly timeLimitMs: number

  constructor(sessions: Sessions, timeLimitMs: number) {
    this.sessions = sessions
    this.timeLimitMs = timeLimitMs
  }

  current = (): Promise<Session> => {
    let timeLimit: ReturnType<typeof setTimeout> | undefined
    const unknownAfterTimeLimit = new Promise<Session>(resolve => {
      timeLimit = setTimeout(
        () => resolve(new UnknownSession()),
        this.timeLimitMs
      )
    })
    return Promise.race([this.sessions.current(), unknownAfterTimeLimit])
      .catch(() => new UnknownSession())
      .finally(() => clearTimeout(timeLimit))
  }
}
